import React from "react";
import SearchPickEmployeeView from "./SearchPickEmployeeView/SearchPickEmployeeView";

import useDynamicSearch from "../../../../hook/useDynamicSearch";

import { MemberListViewItem } from "../../../team/components/common/MembersListView/MemberListView";

import { Pagination as pagniationType } from "../../../../types/responsesAPI.types";
import useErrorHandler from "../../../../hook/useErrorHandler";
import userAPI from "../../services/user.api";
import { User } from "../../types/user.types";

export interface SearchPickUserPresenterProps {
  onClickEmployeeFound: (employee: User) => void;
   employeeProhibitedList?: ProhibitedItem[];
}
export interface ProhibitedItem {
  id: string;
  /* Why is prohibded*/
  description: string;
}

export default function SearchPickUserPresenter({
  onClickEmployeeFound,
  employeeProhibitedList,
}: SearchPickUserPresenterProps) {
  const [result, setResult] = React.useState<User[]>([]);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [paginationInfo, setPaginationInfo] = React.useState<pagniationType | null>(null);

  const {handleNetworkError} = useErrorHandler()
  const memberListItemConverter = (employee: User): MemberListViewItem => {

    if(employeeProhibitedList){
      const isProhibited = employeeProhibitedList.find((item) => item.id === employee.user_id);
      if(isProhibited){
        return {
          firstName: employee.username,
          lastName: employee.lastname,
          email: isProhibited.description
        };
      }
    }
    return {
      firstName: employee.username,
      lastName: employee.lastname,
      email: employee.email,
      plusIconRight: true,
      onClick: () => {
        onClickEmployeeFound(employee);
      },
    };
  };

  const employeeListConverter = (
    employees: User[]
  ): MemberListViewItem[] => {

    return employees.map((employee) => memberListItemConverter(employee));
  };
  const getSearch = (query: string, callback: () => void) => {

    userAPI.searchUserProtectedAPI(query, currentPage, 10, {user_is_active: true})
      .then((response) => {
        setResult(response.data || []);
        setPaginationInfo(response.pagination);
        callback();
      })
      .catch((error) => {
        handleNetworkError(error, "employeeSearch")
        console.error(error);
        callback();
      });
  };


  const [query, setQuery, isLoadingResult, refrechSearch] = useDynamicSearch(getSearch, 0);
  const onSetPagination = (page: number) => {
    setCurrentPage(page);
    refrechSearch();
  }

  const onSetQuery = (query: string) => {
    setCurrentPage(1);
    setPaginationInfo(null);
    setQuery(query);
  }  
  return (
    <>
    <SearchPickEmployeeView
      searchValue={query}
      setSearchValue={onSetQuery}
      isLoading={isLoadingResult}
      employeeFound={employeeListConverter(result)}
      nbEmployeeFound={paginationInfo?.total_count}
      currentPage={currentPage} setCurrentPage={  onSetPagination} lastPage={paginationInfo?.total_pages }
    />

    </>
  );
}
